import { Outlet } from "@solidjs/router";
import { LandingViewProps } from "../models";
import { splitProps } from "solid-js";
import { Cmp, Ctrl } from ":mods";

export function Landing(props: LandingViewProps) {
  const [local, others] = splitProps(props, ["topNav"]);
  // const { id } = Ctrl.Context.hooks.useAppFlavor();
  // const is_mobile = window.matchMedia("only screen and (max-width: 760px)").matches;

  return (
    <section {...others} class={`flex flex-col w-full !min-h-full trim$ !pb-15 ${others.class ?? ""}`}>
      <Ctrl.Nav.Top {...local.topNav} class={`nav-top ${local.topNav?.class ?? ""}`} />
      <div class="flex flex-col w-full min-h-full text#p bg#paper flow$h trim$w">
        <Outlet />
        <footer class="!fixed !bottom-0 flex gap-20px text-16px font-normal py-20px items-center justify-center flex-row w-full h-fit bg#paper text#p">
          <p>©Museums Future 2023</p>
          <p>|</p>
          <Cmp.I18n.LanguageSelector class="font-bold text#p" darkIcon />
          <p>|</p>
          <div class="flex gap-20px children:(cursor-pointer)">
            <i
              class="icon-local:twitter w-25px h-26px"
              onclick={() => {
                window.open(
                  "https://twitter.com/MOCMuseums?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor",
                  ""
                );
              }}
            />
            <i
              class="icon-local:facebook w-26px h-26px"
              onclick={() => {
                window.open("https://museums.moc.gov.sa/", "");
              }}
            />
            <i
              class="icon-local:instagram w-26px h-26px"
              onclick={() => {
                window.open("https://instagram.com/museums_moc?igshid=Y2dqZHl3d2U4ZnY4", "");
              }}
            />
          </div>
        </footer>
      </div>
    </section>
  );
}
